import React from "react";
import clsx from "clsx";
import DateHelper from "../../DateHelper/DateHelper";
import numeral from "numeral";

class AutoPriceRulePresenterGeneral extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00'
    };
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderGeneralForm()}
      </div>
    )
  }

  renderGeneralForm() {
    const pace_array = this.props.pace_array
    const occupancy_array = this.props.occupancy_array

    this.props.auto_price_rules_for_date_range.map((rule) => {
      pace_array.map((pace) => {
        if(rule.order == pace.order) {
          pace_array.splice(pace_array.indexOf(pace), 1)
          pace.id = rule.id
          pace_array.push(pace)
        }
      })
    })

    this.props.auto_price_rules_for_date_range.map((rule) => {
      occupancy_array.map((occupancy) => {
        if(rule.order == occupancy.order) {
          occupancy_array.splice(occupancy_array.indexOf(occupancy), 1)
          occupancy.id = rule.id
          occupancy.occupancy_percentage = rule.occupancy_percentage
          occupancy_array.push(occupancy)
        }
      })
    })

    pace_array.sort((a, b) => a.order - b.order)
    occupancy_array.sort((a, b) => a.order - b.order)
    return (
      <div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <div>{this.props.code}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <div>{this.props.name}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('status')}*</label>
              <div>{I18n.t(this.props.status)}</div>
            </div>
          </div>
        </div>
        <br />

        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('begins')}</label>
              <div>{DateHelper.printDateToScreen(this.props.start_date, this.props.date_format)}</div>

            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('ends')}</label>
              <div>{DateHelper.printDateToScreen(this.props.end_date, this.props.date_format)}</div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('begin_days_out')}*</label>
              <div>{this.props.begin_days_out}</div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('end_days_out')}*</label>
              <div>{this.props.end_days_out}</div>
            </div>
          </div>
        </div>
        <br />     
        {this.props.auto_price_type == "pace" 
          ?
            this.renderAmountorPercentageForPace(pace_array)
          :
            this.renderAmountorPercentageForOccupancy(occupancy_array)
        }
      </div>
    )
  }

  renderAmountorPercentageForPace(pace_array) { 
    var paces = pace_array.map((pace, idx) => {
      var amount = null 
      var percentage = null
      var room_types = []
      var auto_price_rates = []
      var order = null

      this.props.auto_price_rules_for_date_range.forEach((rule) => {
        if(rule.pace_selector == pace.pace_selector) {
          amount = rule.amount
          percentage = rule.percentage
          room_types = rule.room_types
          auto_price_rates = rule.auto_price_rates
          order = rule.order
        }
      })

      return (
        <div className="col-sm-3" key={idx}>
          <div className="panel panel-default" style={{ marginBottom: 0 }}>
            <div className="panel-body container" style={{backgroundColor: "#eee"}}>
              <div className="row" style={{display: "flex", justifyContent: "flex-end", margin: "5px"}}>
                <div className="col-md-6" style={{marginRight: "auto"}}>
                  <label>{I18n.t("last_year")}</label>
                </div> 
              </div>
              <hr />
              <span>
                <div style={{width: '20px', height: '20px', display: 'inline-block', backgroundColor: pace.color, position: 'relative', top: '5px'}}></div>
                {`  ${I18n.t(pace.pace_selector)} ${pace.percentage}`}
                <span></span>
              </span>
              <div className="row" style={{paddingTop: '10px'}}>
                <div className="col-md-5">
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label>{I18n.t('amount')} <span className="ss-help help" title={I18n.t('rate_amount_helper_text')}></span></label>
                    <div>{amount ? this.formatCurrency(amount) : null}</div>  
                  </div>
                </div>

                <div className="col-md-2 or-col">
                  <div className="input-group input-group-currency maxlength7">{I18n.t('or')}</div>
                </div>

                <div className="col-md-5">
                  <div className="form-group percentage-form-group">
                    <label>{I18n.t('percentage')} <span className="ss-help help" title={I18n.t('rate_percentage_helper_text')}></span></label>
                    <div>{percentage ? this.formatPercentage(percentage) : null}</div>
                  </div>
                </div>
              </div>

              {this.renderRoomTypes(room_types)}
              {this.renderRates(auto_price_rates)}  
            </div>
          </div>
        </div>    
      ) 
    }) 
    return (
      <div className= "row">
        {paces}
      </div>
    )  
  }

  renderAmountorPercentageForOccupancy(occupancy_array) {

    var occupancies = occupancy_array.map((occupancy, idx) => {
      var amount = null
      var percentage = null
      var room_types = []
      var auto_price_rates = []
      var occupancy_comparator = null
      var occupancy_percentage = null
      var order = null

      this.props.auto_price_rules_for_date_range.forEach((rule) => {
        if (rule.occupancy_percentage == occupancy.occupancy_percentage) {
          amount = rule.amount
          percentage = rule.percentage
          room_types = rule.room_types
          auto_price_rates = rule.auto_price_rates
          occupancy_comparator = rule.occupancy_comparator
          occupancy_percentage = rule.occupancy_percentage
          order = rule.order
        }
      })
      return (
        <div className="col-sm-3" key={idx} >
          <div className="panel panel-default" style={{ marginBottom: 0 }}>
            <div className="panel-body container" style={{backgroundColor: "#eee"}}>
              <div className="row" style={{display: "flex", justifyContent: "space-betweem", margin: "5px"}}>
                <div className="col-md-6" style={{marginRight: "auto"}}>
                  <label >{I18n.t("occupancy")}</label>
                </div>
              </div>
              <hr />
              <div className="row">   
                <br />
                <div style={{marginRight: "auto", paddingLeft: "10px"}}>{occupancy_comparator ? I18n.t(occupancy_comparator) : I18n.t(occupancy.occupancy_comparator)}</div>   
                <div className="col-md-4">
                  <span>
                    {`  ${this.formatPercentage(occupancy.occupancy_percentage)}`}
                    <span></span>
                  </span>
                </div>
              </div>
              <div className="row" style={{paddingTop: '10px'}}>
                <div className="col-md-5">
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label>{I18n.t('amount')} <span className="ss-help help" title={I18n.t('rate_amount_helper_text')}></span></label>
                    <div>{amount ? this.formatCurrency(amount) : null}</div>
                  </div>
                </div>
                <div className="col-md-2 or-col">
                  <div className="input-group input-group-currency maxlength7">{I18n.t('or')}</div>
                </div>
                <div className="col-md-5">
                  <div className="form-group percentage-form-group">
                    <label>{I18n.t('percentage')} <span className="ss-help help" title={I18n.t('rate_percentage_helper_text')}></span></label>
                    <div>{percentage ? this.formatPercentage(percentage) : null}</div>
                  </div>
                </div>
              </div>
              {this.renderRoomTypes(room_types)}
              {this.renderRates(auto_price_rates)}
            </div>
          </div>
        </div>
      )
    })
    return (
      <div className= "row">
        {occupancies}
      </div>
    )  
  }

  renderRoomTypes(room_type_ids) {
    const room_type_names = []
    if(room_type_ids.length > 0) {
      room_type_ids.map((id) => {
        this.props.all_room_types.forEach((type) => {
          if(type.id == id) {
            const room_type = type.name
            room_type_names.push(room_type)
          }
        })
      })
      var room_type_list = room_type_names.map((name, idx) => {
        return (
          <li key={idx}>{name}</li>
        )
      })
      return (
        <div className="row" style={{paddingTop: '10px'}}>
          <div className="col-md-12">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t('room_types')} <span className="ss-help help" title={I18n.t('rate_amount_helper_text')}></span></label>
              <ul>
                {room_type_list}
              </ul>
            </div>
          </div>
        </div>
      )
    }
  }

  renderRates(auto_price_rate_ids) {
    const auto_price_rate_names = []
    if(auto_price_rate_ids.length > 0) {
      auto_price_rate_ids.map((id) => {
        this.props.all_rates.forEach((rate) => {
          if(rate.id == id) {
            const auto_price_rate = rate.name
            auto_price_rate_names.push(auto_price_rate)
          }
        })
      })
      var auto_price_rate_list = auto_price_rate_names.map((name, idx) => {
        return (
          <li key={idx}>{name}</li>
        )
      })
      return (
        <div className="row" style={{paddingTop: '10px'}}>
          <div className="col-md-12">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t('rates')} <span className="ss-help help" title={I18n.t('rate_amount_helper_text')}></span></label>
              <ul>
                {auto_price_rate_list}
              </ul>
            </div>
          </div>
        </div>
      )
    }
  }

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  formatPercentage(num) {
    return parseFloat((num * 100).toFixed(2)) + "%"
  };

}

export default AutoPriceRulePresenterGeneral
